import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';
import useRoutes from '../../components/_hook/useRoutes';
import Context from '../../context';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#404040',
    color: 'white',
  },
});
export default function SubscribeCompanyPremiumAdvertisement() {
  const classes = useStyles();
  const { path } = useRoutes();
  const { company } = useContext(Context);
  const { t } = useTranslation();
  return (
    <>
      <Card variant="outlined" className={classes.root}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>
            {t('maximize_your_business_potential')}
          </Typography>
          <Typography variant="h6" align="center">
            {t('upgrade_your_business_listing_for_unlimited_contents')}
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            size="large"
            fullWidth
            color="primary"
            variant="contained"
            component={Link}
            to={path('plan.subscriptions', {
              companyID: company._id,
            })}
          >
            {t('subscribe')}
          </Button>
        </CardActions>
      </Card>
    </>
  );
}
